// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"disclaimer_disclaimer__8sgX2"};